/*jshint esversion: 6 */

const config = {
  production: "production",
  staging: "staging",
  development: "development",
};

// Region Configs
const regionConfig = {
  GB: {
    region: "GB",
    locale: "EN-GB",
    hasOptedIntoStatisticsTracking: false,
  },
  IE: {
    supportedRegion: "IE",
    hasOptedIntoStatisticsTracking: false,
  },
  US: {
    region: "US",
    locale: "EN-US",
    hasOptedIntoStatisticsTracking: true,
  },
};
const DEFAULT_REGION = "US";

function getEnvConfig() {
  let env = "development";
  let host = location.host;
  if (host === "cash.app" || host === "cash.me") {
    env = "production";
  } else if (host === "cashstaging.app" || host === "cashstaging.me") {
    env = "staging";
  }

  return config[env] || {};
}

function getRegionConfig() {
  var country = getCountry(window.countryGuess);
  return regionConfig[country];
}

function getCountry(countryGuess) {
  if (!regionConfig[countryGuess]) {
    return DEFAULT_REGION;
  }

  return regionConfig[countryGuess].supportedRegion || countryGuess;
}

// Sets Environment variables.
export default {
  getEnvConfig,
  getRegionConfig,
};
